import styled from '@olxui/core/dist/theme/styled';
import { Divider } from '@olxui/core/dist/core/Divider';
import { Button } from '@olxui/core/dist/core/Button';
import { CSS_MOBILE_MEDIA_QUERY } from '@olxpwa-lib/utils/constants';
import { P3, P4 } from '@olxui/core/dist/core/Typography';

export const AdCardTitle = styled(P3)`
    text-transform: uppercase;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    margin-bottom: ${({ theme }) => theme.space[20]};
`;

export const BookingTitle = styled(AdCardTitle)`
    margin-bottom: 0.75em;
`;

export const BookingDescription = styled(P4)`
    margin-bottom: 1.5em;
`;

export const BookingDivider = styled(Divider)`
    margin-top: 1.25em;
    margin-bottom: 1.25em;

    ${CSS_MOBILE_MEDIA_QUERY} {
        display: none;
    }
`;

export const BookingInfoLinkWrapper = styled.div`
    text-align: center;
`;

export const BookingInfoLink = styled(Button)<{ isMobile: boolean }>`
    font-size: 14px;
    margin-top: ${({ isMobile }) => (isMobile ? 16 : 0)}px;
`;
